import React from 'react';
import UserStyle from 'pages/Admin/Users/Users.module.css';
import { getPrimaryTextClass } from 'helpers/sf_utils';
import { FILTER_COMPONENT_TYPES, YES_AND_NO } from 'helpers/sf_constants';

const ShowAppliedFilters = ({ filtered_columns, onClickRemoveFilter }) => {
    return (
        <div className="d-flex flex-wrap align-items-center">
            {
                filtered_columns && filtered_columns.map((item, idx) => {
                    let filter_values = item?.value || '';
                    switch (item.component_type) {
                        case FILTER_COMPONENT_TYPES.SINGLE_SELECT:
                            filter_values = <span className='text-capitalize'>{(item?.value?.value === YES_AND_NO.NO || !item?.value?.value) ? YES_AND_NO.NO : (item?.value?.value === YES_AND_NO.YES || !item?.value?.value) ? YES_AND_NO.YES : item?.value?.label}</span>
                            break;
                        case FILTER_COMPONENT_TYPES.MULTI_SELECT:
                            filter_values = ((item?.value || [])?.map(el => el.label) || []).join(', ')
                            break;
                        case FILTER_COMPONENT_TYPES.DATE_RANGE:
                            filter_values = item?.value?.label
                            break;
                        case FILTER_COMPONENT_TYPES.COMPARATOR:
                            filter_values = (`${item?.value?.label} : ${item?.comparator_value}`)
                            break;
                        default:
                            break;
                    }
                    return (
                        <div key={idx} className={`mx-2 mb-1 ${UserStyle.selected_filter}`}>
                            <div className="d-flex align-items-center">
                                <span>{item?.label} : <b>{filter_values}</b></span>
                                <a className={`ms-2 ${getPrimaryTextClass()} font-size-18`} onClick={() => onClickRemoveFilter(item?.name)} style={{ cursor: "pointer" }}>
                                    <span aria-hidden="true">&times;</span>
                                </a>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default ShowAppliedFilters;

